<template>
  <a-card title="Jaminan BPJS" :loading="loading.page">
    <template slot="extra">
        <a-button v-if="isHRD && mode!='Ubah'" type="secondary" icon="edit" :loading="loading.save" :disabled="loading.page" @click="setubah">Ubah Data</a-button>
    </template>
    <a-row :gutter="10">
      <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
        <a-tag class="tag-check">
          <a-checkbox v-model="jaminan.kes_per" @click="(e)=>{!isHRD || (isHRD && mode!='Ubah') ? e.preventDefault() : true}" :class="'checkbox-bpjs'+(!jaminan.kes_per ? ' linethrough' : ' textbold')">
            Kesehatan ditanggung Perusahaan (<i>KES_PER</i>)
          </a-checkbox>
        </a-tag>
        <a-tag class="tag-check">
          <a-checkbox v-model="jaminan.kes_kar" @click="(e)=>{!isHRD || (isHRD && mode!='Ubah') ? e.preventDefault() : true}" :class="'checkbox-bpjs'+(!jaminan.kes_kar ? ' linethrough' : ' textbold')">
            Kesehatan ditanggung Karyawan (<i>KES_KAR</i>)
          </a-checkbox>
        </a-tag>
        <a-tag class="tag-check">
          <a-checkbox v-model="jaminan.jkk_per" @click="(e)=>{!isHRD || (isHRD && mode!='Ubah') ? e.preventDefault() : true}" :class="'checkbox-bpjs'+(!jaminan.jkk_per ? ' linethrough' : ' textbold')">
            Jaminan Kecelakaan Kerja Perusahaan (<i>JKK_PER</i>)
          </a-checkbox>
        </a-tag>
        <a-tag class="tag-check">
          <a-checkbox v-model="jaminan.jkm_per" @click="(e)=>{!isHRD || (isHRD && mode!='Ubah') ? e.preventDefault() : true}" :class="'checkbox-bpjs'+(!jaminan.jkm_per ? ' linethrough' : ' textbold')">
            Jaminan Kematian Perusahaan (<i>JKM_PER</i>)
          </a-checkbox>
        </a-tag>
      </a-col>
      <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
        <a-tag class="tag-check">
          <a-checkbox v-model="jaminan.jht_per" @click="(e)=>{!isHRD || (isHRD && mode!='Ubah') ? e.preventDefault() : true}" :class="'checkbox-bpjs'+(!jaminan.jht_per ? ' linethrough' : ' textbold')">
            Jaminan Hari Tua Perusahaan(<i>JHT_PER</i>)
          </a-checkbox>
        </a-tag>
        <a-tag class="tag-check">
          <a-checkbox v-model="jaminan.jht_kar" @click="(e)=>{!isHRD || (isHRD && mode!='Ubah') ? e.preventDefault() : true}" :class="'checkbox-bpjs'+(!jaminan.jht_kar ? ' linethrough' : ' textbold')">
            Jaminan Hari Tua Karyawan (<i>JHT_KAR</i>)
          </a-checkbox>
        </a-tag>
        <a-tag class="tag-check">
          <a-checkbox v-model="jaminan.jp_per" @click="(e)=>{!isHRD || (isHRD && mode!='Ubah') ? e.preventDefault() : true}" :class="'checkbox-bpjs'+(!jaminan.jp_per ? ' linethrough' : ' textbold')">
            Jaminan Pensiun Perusahaan (<i>JP_PER</i>)
          </a-checkbox>
        </a-tag>
        <a-tag class="tag-check">
          <a-checkbox v-model="jaminan.jp_kar" @click="(e)=>{!isHRD || (isHRD && mode!='Ubah') ? e.preventDefault() : true}" :class="'checkbox-bpjs'+(!jaminan.jp_kar ? ' linethrough' : ' textbold')">
            Jaminan Pensiun Karyawan (<i>JP_KAR</i>)
          </a-checkbox>
        </a-tag>
      </a-col>
    </a-row>
    <a-row :gutter="10">
      <a-col :xs="{ span: 24}" :lg="{ span: 12 }" :class="'checkbox-bpjs'">
        <a-tag class="tag-check">
          <div>
            <a-checkbox v-model="jaminan.kes_tambahan" @click="(e)=>{!isHRD || (isHRD && mode!='Ubah') ? e.preventDefault() : true}" :class="'checkbox-bpjs'+(!jaminan.kes_tambahan ? ' linethrough' : ' textbold')" style="margin-left: 8px;">
              Kesehatan Tambahan (<i>kes_tambahan</i>)
            </a-checkbox>
          </div>
          <a-input-number v-model="jaminan.value_kes_tambahan" autocomplete="off" 
            @keydown="onlyNumber" 
            :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            :disabled="!isHRD || !jaminan.kes_tambahan || mode=='View'" 
            :min="0"
            class="h-currency"
            style="margin-left:36px;margin-bottom:10px;min-width: 200px;"
            />
        </a-tag>
      </a-col>
    </a-row>
    <template v-if="isHRD && mode=='Ubah'" slot="actions">
      <a-button type="primary" icon="save" :loading="loading.save" :disabled="loading.page" @click="save">Simpan</a-button>
    </template>
  </a-card>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name:"bpjs",
  props: ["data","tlc"],
  data() {
    return {
      jaminan: {
        kes_per: true,
        jkk_per: true,
        jkm_per: true,
        jp_per: true,
        jht_per: true,
        kes_kar: true,
        jp_kar: true,
        jht_kar: true,
        kes_tambahan: true,
        value_kes_tambahan: null
      },
      loading:{
        page: true,
        save: false
      },
      mode: 'View'
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    isHRD(){
      return this.$route.meta.isHRD
    }
  },
  mounted(){
    this.fetchData()
  },
  methods: {
    async fetchData(){
      this.loading.page = true
      const payload = {
        tlc: this.tlc
      }
      try {
        const response = await this.asyncAxiosGet("master_karyawan/bpjs", this.getAuth, payload);
        this.jaminan = {
          kes_per: response.kes_per=="1",
          jkk_per: response.jkk_per=="1",
          jkm_per: response.jkm_per=="1",
          jp_per: response.jp_per=="1",
          jht_per: response.jht_per=="1",
          kes_kar: response.kes_kar=="1",
          jp_kar: response.jp_kar=="1",
          jht_kar: response.jht_kar=="1",
          kes_tambahan: response.kes_tambahan=="1",
          value_kes_tambahan: response.value_kes_tambahan
        }
        this.loading.page = false
      } catch (error) {
        this.loading.page = false
        console.log(error);
        this.displayMessageValue("error-basic", error);
      }
    },
    setubah(){
      this.mode = 'Ubah'
    },
    save(){
      if(this.jaminan.kes_tambahan && (this.jaminan.value_kes_tambahan==null || this.jaminan.value_kes_tambahan==0)){
        this.displayMessageValue("warning-basic", 'Nilai kesehatan tambahan harus lebih dari 0!');
        return
      }
      this.loading.save = true
      this.asyncAxiosPost("master_karyawan/bpjs", "application/json", this.getAuth,
      {
        tlc: this.tlc,
        kes_per: this.jaminan.kes_per?"1":"0",
        kes_kar: this.jaminan.kes_kar?"1":"0",
        jht_per: this.jaminan.jht_per?"1":"0",
        jht_kar: this.jaminan.jht_kar?"1":"0",
        jp_per: this.jaminan.jp_per?"1":"0",
        jp_kar: this.jaminan.jp_kar?"1":"0",
        jkk_per: this.jaminan.jkk_per?"1":"0",
        jkm_per: this.jaminan.jkm_per?"1":"0",
        kes_tambahan: this.jaminan.kes_tambahan?"1":"0",
        value_kes_tambahan: this.jaminan.kes_tambahan ? this.jaminan.value_kes_tambahan: null
      })
      .then(() => {
        this.displayMessage("success-save");
        this.loading.save = false
        this.mode = 'View'
      })
      .catch((err) => {
        console.log(err);
        this.displayMessageValue("error-basic", err);
        this.loading.save = false
      });
    },
  }
}
</script>
<style lang="less">
.tag-check{
  margin-bottom: 10px!important;
  width: 100%;
}
.checkbox-bpjs{
  margin: 8px 0 8px 0!important;
}
.h-currency{
  .ant-input-number-input-wrap{
    .ant-input-number-input{
      text-align: right!important;
      padding-right: 25px;
    }
  }
}
.textbold{
  font-weight: bold;
}
// .linethrough{
//   text-decoration: line-through;
// }
</style>